/***************************************************************************/
"use client";
/***************************************************************************/

import React from "react";

const Screen: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
  children,
  ...props
}) => {
  return (
    <div
      {...props}
      className={["flex-1 flex flex-col gap-4", className]
        .filter(Boolean)
        .join(" ")}
    >
      {children}
    </div>
  );
};

export { Screen };
